import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react'
import { Link, type LinkProps } from 'react-router-dom'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode
  variant?: 'primary' | 'quiet' | 'light'
  ref?: Ref<HTMLButtonElement>
}

export function Button({
  children,
  className = '',
  variant = 'primary',
  ref,
  ...props
}: ButtonProps) {
  return (
    <button ref={ref} className={`button button--${variant} ${className}`} {...props}>
      {children}
    </button>
  )
}

export function ButtonLink({
  children,
  className = '',
  ...props
}: LinkProps & { children: ReactNode }) {
  return (
    <Link className={`button button--primary ${className}`} {...props}>
      {children}
    </Link>
  )
}
